import { ColorValueObjectRecursive, HoneycombThemeBase } from '../types';
import { resolveFlatColorObject } from './resolveFlatColorObject';

export function resolveRecursiveColorObject(theme: HoneycombThemeBase) {
    const resolveFlatObject = resolveFlatColorObject(theme);

    const resolveColors = (colorObj: ColorValueObjectRecursive): ColorValueObjectRecursive =>
        Object.fromEntries(
            Object.entries(colorObj).map(([key, value]) => [
                key,
                typeof value === 'object' && value !== null
                    ? resolveColors(value)
                    : resolveFlatObject({ [key]: value })[key],
            ])
        );

    return resolveColors;
}
